import React from 'react';
import clsx from 'clsx';
import CloseIcon from '@/shared/icons/CloseIcon';
import ButtonIcon from '@/shared/components/UI/ButtonIcon';
import LightbulbIcon from '@/v3-dashboard/components/UI/Icons/LightbulbIcon';


const DismissableExplainerCard = ({ copy, onDismiss, className = '' }) => {
  return (
    <div
      className={clsx(
        'flex items-start gap-v3-xs pl-v3-ms pr-v3-ms  w-full bg-white rounded-v3-sm border border-v3-card-border font-inter-variable',
        className
      )}
    >
      <LightbulbIcon className="flex-shrink-0 mt-v3-sm" />
      <p className="flex-1 text-v3-h9 font-normal py-v3-sm text-v3-black-primary">
        {copy}
      </p>
      <div className='pt-v3-ms'>
         <ButtonIcon
        icon={CloseIcon}
        size="xs"
        onClick={onDismiss}
        aria-label="Dismiss"
        className="text-v3-black-secondary"
      />
      </div>
    </div>
  );
};

export default DismissableExplainerCard;
